import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { CheckIcon } from '@heroicons/react/24/solid'

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
    },
  },
}

export default function Hero() {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1502877338535-766e1452684a?w=1920&q=80"
          alt="Professional driving instruction"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/80" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 py-20">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="max-w-3xl"
        >
          {/* Badge */}
          <motion.div variants={itemVariants}>
            <div className="inline-flex items-center gap-2 bg-accent text-primary px-4 py-2 rounded-full font-heading font-semibold text-sm mb-6">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              DMV Licensed & Certified
            </div>
          </motion.div>

          {/* Headline */}
          <motion.h1
            variants={itemVariants}
            className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-6 leading-tight"
          >
            Learn to Drive with{' '}
            <span className="text-accent">Confidence</span>
          </motion.h1>

          {/* Description */}
          <motion.p
            variants={itemVariants}
            className="text-xl text-white/90 mb-8 max-w-2xl"
          >
            Virginia&apos;s premier driving school offering comprehensive driver education for teens and adults. Professional instructors, flexible schedules, and proven success rates.
          </motion.p>

          {/* CTAs */}
          <motion.div
            variants={itemVariants}
            className="flex flex-wrap gap-4 mb-8"
          >
            <Link
              to="/register"
              className="px-8 py-4 bg-accent text-primary font-heading font-semibold rounded-full hover:scale-105 hover:shadow-lift transition-all inline-flex items-center gap-2"
            >
              Register Now
              <span>&gt;</span>
            </Link>
            {/* <Link
              to="/pay-online"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white font-heading font-semibold rounded-full hover:bg-white hover:text-primary transition-colors"
            >
              Pay Online
            </Link> */}
          </motion.div>

          {/* Trust Badges */}
          <motion.div
            variants={itemVariants}
            className="flex flex-wrap gap-6 text-white"
          >
            {/* <div className="flex items-center gap-2">
              <CheckIcon className="w-5 h-5 text-accent" />
              <span className="font-semibold">98% Pass Rate</span>
            </div> */}
            <div className="flex items-center gap-2">
              <CheckIcon className="w-5 h-5 text-accent" />
              <span className="font-semibold">5000+ Graduates</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckIcon className="w-5 h-5 text-accent" />
              <span className="font-semibold">14+ Years Experience</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

